@let widgetData = data();

<div [id]="form.displayId()" class="form-root" [class]="rootFormWithPositionClasses()" [style]="rootCssVars()">
    @if (form?.formView().value() !== EFormView.modal) {
        <form>
            <div class="form-fields-container">
                @for (control of widgetData.elements; track $index) {
                    @if (control.type !== formInputType.hidden) {
                        <div class="form-field" [class]="fieldCssClasses()">
                            @switch (true) {
                                @case (typeGuards.isInput(control)) {
                                    @if (widgetData.inputSettings.showLabels) {
                                        <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                    }
                                    @if (!control.isDynamicPlaceholderEnabled && control.type !== "file") {
                                        <input
                                            class="form-control"
                                            [class]="fieldCssClasses()"
                                            [attr.type]="control.htmlInputType"
                                            [attr.placeholder]="control.placeholder"
                                        />
                                    }
                                    @if (control.type === "phone" && control.isDynamicPlaceholderEnabled) {
                                        <ngx-intl-tel-input
                                            [cssClass]="'form-control ' + fieldCssClasses()"
                                            [enableAutoCountrySelect]="true"
                                            [selectFirstCountry]="false"
                                            [separateDialCode]="true"
                                            [enablePlaceholder]="true"
                                            [searchCountryFlag]="true"
                                            [phoneValidation]="true"
                                            [searchCountryField]="[SearchCountryField.All]"
                                            [excludeCountries]="excludeCountries"
                                            [selectedCountryISO]="CountryISO"
                                            [numberFormat]="PhoneNumberFormat.International"
                                        />
                                    }
                                    @if (control.type === "file") {
                                        <div class="ngx-dropzone-file">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M3 11C3.55228 11 4 11.4477 4 12V17C4 18.6568 5.34315 20 7 20H17C18.6568 20 20 18.6568 20 17V12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12V17C22 19.7614 19.7614 22 17 22H7C4.23857 22 2 19.7614 2 17V12C2 11.4477 2.44772 11 3 11Z"
                                                    fill="#3A83A2"
                                                />
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.4001 3.2C11.7556 2.93333 12.2445 2.93333 12.6001 3.2L16.6001 6.2C17.0419 6.53137 17.1314 7.15817 16.8001 7.6C16.4687 8.04183 15.8419 8.13137 15.4001 7.8L13.0001 6V15C13.0001 15.5523 12.5523 16 12.0001 16C11.4478 16 11.0001 15.5523 11.0001 15V6L8.60006 7.8C8.15823 8.13137 7.53143 8.04183 7.20006 7.6C6.86869 7.15817 6.95823 6.53137 7.40006 6.2L11.4001 3.2Z"
                                                    fill="#3A83A2"
                                                />
                                            </svg>
                                            <p>{{ control.placeholder | translate }}</p>
                                        </div>
                                    }
                                }
                                @case (typeGuards.isTextarea(control)) {
                                    @if (widgetData.inputSettings.showLabels) {
                                        <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                    }
                                    <textarea
                                        class="form-control-textarea"
                                        [class]="fieldCssClasses()"
                                        [attr.placeholder]="control.placeholder"
                                    ></textarea>
                                }
                                @case (typeGuards.isCheckbox(control)) {
                                    <label class="sp-checkbox">
                                        <input [attr.type]="control.htmlInputType" />
                                        @if (control.required) {
                                            <span
                                                class="checkbox-text"
                                                [innerHTML]="' ' + (control.label | removePTags) + ' *'"
                                            ></span>
                                        } @else {
                                            <span
                                                class="checkbox-text"
                                                [innerHTML]="' ' + (control.label | removePTags)"
                                            ></span>
                                        }
                                    </label>
                                }
                                @case (typeGuards.isRadio(control)) {
                                    @if (widgetData.inputSettings.showLabels) {
                                        <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                    }
                                    @for (option of control.options; track $index) {
                                        <div class="radio-options">
                                            <label>
                                                <input
                                                    [attr.type]="control.htmlInputType"
                                                    [value]="option.value"
                                                    [checked]="option.selected"
                                                />
                                                <span class="radio-text"> {{ option.label }}</span>
                                            </label>
                                        </div>
                                    }
                                }
                                @case (typeGuards.isSelect(control)) {
                                    @if (widgetData.inputSettings.showLabels) {
                                        <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                    }
                                    <ng-select
                                        class="form-control"
                                        [class]="fieldCssClasses()"
                                        [placeholder]="getPlaceholder(control.options) | translate"
                                        [items]="control.options"
                                        [multiple]="$any(control.htmlInputType) === 'multiselect'"
                                    />
                                }
                            }
                        </div>
                    }
                }

                @if (!widgetData.addChatBotToForm) {
                    <div class="form-button-wrapper" [class]="buttonWrapperCssClasses()" [style]="buttonCssVars()">
                        <a [class]="getButtonStyles(widgetData.formButtonSettings)">
                            @if (widgetData.formButtonSettings.buttonIcon?.isActive) {
                                <span
                                    class="icon"
                                    [innerHTML]="getIcon(widgetData.formButtonSettings.buttonIcon?.icon)"
                                ></span>
                            }
                            {{ widgetData.formButtonSettings.label }}
                        </a>
                    </div>
                } @else {
                    <div class="form-chatbot-wrapper" [class]="chatBotWrapperCssClasses()" [style]="chatBotCssVars()">
                        @for (chatBot of widgetData.chatBots; track $index) {
                            <a [class]="getStyleList(chatBot.socialNetwork)">
                                <div [innerHTML]="getChatBotIcon(chatBot.socialNetwork)" class="icon"></div>
                                <span>{{ chatBot.name }}</span>
                            </a>
                        }
                    </div>
                }
            </div>
        </form>
    } @else {
        @if (widgetData?.isTwoStepForm) {
            @for (control of widgetData.elements; track $index) {
                @if (control.type === formInputType.email) {
                    <div class="form-field" [class]="fieldCssClasses()">
                        @if (widgetData.inputSettings.showLabels) {
                            <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                        }
                        <input
                            class="form-control"
                            [class]="fieldCssClasses()"
                            [attr.type]="control.htmlInputType"
                            [attr.placeholder]="control.placeholder"
                        />
                    </div>
                }
            }
        }

        <div
            class="form-button-wrapper"
            [class]="buttonWrapperCssClasses()"
            [style]="buttonCssVars()"
            [class.button-without-form]="!widgetData?.isTwoStepForm"
        >
            <a [class]="getButtonStyles(widgetData.formButtonSettings)">
                @if (widgetData.formButtonSettings.buttonIcon?.isActive) {
                    <span class="icon" [innerHTML]="getIcon(widgetData.formButtonSettings.buttonIcon?.icon)"></span>
                }
                {{ widgetData.formButtonSettings.label }}
            </a>
        </div>
    }
</div>
